import { Button } from "../../Atoms/Button";
import { Title } from "../../Atoms/Title";
import { FormCollaboratorEdit } from "../../Molecules/FormCollaboratorEdit";
import * as S from "./styles";
import { useCollaboratorDetail } from "./useCollaboratorDetail";

export const CollaboratorDetailTemplate = () => {
  const { handleSubmit, shouldShowResetPasswordButton, handleResetPassword } =
    useCollaboratorDetail();

  return (
    <S.Container>
      <S.Wrapper>
        <Title>Dados do Colaborador</Title>
        {shouldShowResetPasswordButton && (
          <S.WrapperButton>
            <Button onClick={handleResetPassword}>
              <img src="/assets/svgs/icon-replay.svg" alt="icon-reset" />
              Redefinir Senha
            </Button>
          </S.WrapperButton>
        )}
        <FormCollaboratorEdit submitForm={handleSubmit} />
      </S.Wrapper>
    </S.Container>
  );
};
